const routeIdsAreEqual = (prevIds, nextIds) =>
  prevIds === nextIds ||
  (Array.isArray(prevIds) &&
    Array.isArray(nextIds) &&
    prevIds.length === nextIds.length &&
    prevIds.every((id, index) => id === nextIds[index]));

const DISPLAY_KEYS = ['selectedTour', 'showProblem', 'showUnassigned', 'highlightStop'];
const MAP_SETTINGS_KEYS = ['showStops', 'hideVisited', 'showOnlyFirstVisits'];
const ROOT_KEYS = ['geoJSON', 'map', 'ui', 'oAuth', 'translations'];

export function areMarkerPropsEqual(prevProps, nextProps) {
  return (
    ROOT_KEYS.every((key) => prevProps[key] === nextProps[key]) &&
    DISPLAY_KEYS.every((key) => prevProps.display?.[key] === nextProps.display?.[key]) &&
    routeIdsAreEqual(prevProps.display?.routeIds, nextProps.display?.routeIds) &&
    MAP_SETTINGS_KEYS.every(
      (key) => prevProps.user?.mapSettings?.[key] === nextProps.user?.mapSettings?.[key],
    )
  );
}
